module.exports = __webpack_public_path__ + "static/img/wechat_search.94a6e95.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/wechat_search.png
// module id = JzJq
// module chunks = 26